module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad2/img_intro-ai-c81acae516dec050896129b78b11db8a.png";